import { Component, OnInit } from '@angular/core';
import { ISession } from 'src/app/shared/data/session.interface';
import { HistoricoPaginasService } from 'src/app/shared/services/historico-paginas.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { MENU_GROUPS, ISidebarMenuItem } from 'src/app/pages/components/sidebar/sidebar.models';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {
  session!: ISession;
  atalhos: ISidebarMenuItem[] = [];

  constructor(
    private readonly sessionService: SessionService,
    private readonly historicoPaginasService: HistoricoPaginasService
  ) {}

  ngOnInit(): void {
    const session = this.sessionService.getSession();
    this.session = session;

    const userPermissions = session.userdata || [];
    const userRole = session.role;

    const temAcesso = (item: ISidebarMenuItem): boolean =>
      item.permissions?.some((p) => p === userRole || userPermissions.includes(p)) ?? false;

    const rotasVisitadas = this.historicoPaginasService.obterHistorico();
    const atalhosMapeados = rotasVisitadas
      .map((rota) => {
        const routeWithoutDash = rota.replace('/dash/', '');
        return MENU_GROUPS.flatMap((group) => group.items).find((item) => item.route === routeWithoutDash);
      })
      .filter((item): item is ISidebarMenuItem => item !== undefined && temAcesso(item));

    this.atalhos = [...new Set(atalhosMapeados)];
  }
}
